export default "__VITE_ASSET__DUkYc581__"